<template id="child">
    <div v-if="showModal" :style="cssProps">
    <div  class="modal d-flex flex-column">
        <h1>Schedule Date</h1>
        <div class="date-month d-flex flex-row justify-content-between" v-if="workingDays.length > 0">
                <span>{{monthNames[workingDays[0].getMonth()]}}, {{workingDays[0].getFullYear()}}</span>
                <span>{{monthNames[workingDays[workingDays.length - 1].getMonth()]}}, {{workingDays[workingDays.length - 1].getFullYear()}}</span>
        </div>
        <div class="date-days d-flex flex-row">
            <div v-for="(day, index) in workingDays" :key="index">
                <button class="day d-flex flex-column align-items-center justify-content-center" @click="setDay(index)" :class="choosedDayIndex === index ? 'active' : ''">
                    <span>{{day.getDate()}}</span>
                    <span>{{dayNames[day.getDay()]}}</span>
                </button>
            </div>
        </div>
        
        <!-- <span class="not-work" v-if="!isWorkingDay">Delivery is unavailable on chosen day.</span> -->
        <div class="date-time">
            
            <h1>Specify Time</h1>
            
            <scroll-picker :options="options" class="scrollTime" v-model="time"></scroll-picker>
          
            <div class="scroller d-flex flex-row justify-content-between">
            <input type="range" :min="from" :max="to" step="15" v-model="time">
            <span>{{total}}</span>

            </div>
            <div class="beet d-flex flex-row justify-content-between">
                <span>{{convertToHours(from)}}</span>
                <span>{{convertToHours(to)}}</span>
            </div>
            <div class="button d-flex flex-row justify-content-between">
                <button @click="hide">
                    <span>Cancel</span>
                </button>
                <button @click="submit" :disabled="!isWorkingDay">
                    <span>Deliver {{monthNamesShort[workingDays[choosedDayIndex].getMonth()]}} {{workingDays[choosedDayIndex].getDate()}} at {{total}}</span>
                </button>
            </div>
        </div>
    </div>
    <div class="modal-overlay"></div>
  </div>
</template>
<script>

import axios from "axios";
import { mapState } from 'vuex';
import { ScrollPicker, ScrollPickerGroup } from "vue-scroll-picker"
export default {
    components:{
        ScrollPicker,
        ScrollPickerGroup,
    },
    template: '#child',
    data(){
        return{
            showModal: false,
            time: 0,
            workingDays: [],
            monthNames: ["January", "February", "March", "April", "May", "June","July", "August", "September", "October", "November", "December"],
            monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun","Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
            dayNames: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
            deliveryDate: {
                ismanualfire: false,
                year: null,
                month: null,
                day: null,
                hour: null,
                minute: null,
                monthName: null,
                dateName: null,
                fullTime: null
            },
            dayCount: 7,
            choosedDayIndex: 0,
            calendars: null,
            checking: [],
            checkingIndex: null,
            isWorkingDay: true,
            from: 0,
            to: 1425,
            options: []
        }
    },
  methods: {
  	show() {
    	this.showModal = true
    },
    hide(){
    	this.showModal = false
    },
    setDay(index){
        this.choosedDayIndex = index;
    },
    setWorkingHours(){
        let choosedDay = this.workingDays[this.choosedDayIndex];
        let tmpDay;
        let choosedHoursIndex = -1;
        for(let i = 0; i < this.checking.length; i++){
            
            if(this.withoutHours(this.checking[i].start).getTime()  == this.withoutHours(choosedDay).getTime()){
                choosedHoursIndex = i;
            }
        }                                                                                           
        if(choosedHoursIndex !== -1){
            this.checkingIndex = choosedHoursIndex;
            this.isWorkingDay = true;
            this.setFromTo();
            this.setMobileOptions();
            this.time = this.from;
        } 
        else{
            this.isWorkingDay = false;
            this.time = 0;
            this.from = 0;
            this.to = 0;
            this.options = [];
        }         
    },
    withoutHours(day){
        let newDay = new Date(day.getTime());
        newDay.setHours(0, 0, 0, 0);
        return newDay;
    },
    setFromTo(){
        let choosedDay = this.checking[this.checkingIndex];
        this.from = choosedDay.start.getTime() - this.withoutHours(choosedDay.start).getTime();
        this.from = this.from / 1000 / 60;
        this.to = choosedDay.end.getTime() - this.withoutHours(choosedDay.end).getTime();
        this.to = this.to / 1000 / 60;
        this.time = this.from;
    },
    setMobileOptions(){
        this.options = [];
        for(let i = this.from; i <= this.to; i += 15){
            this.options.push({value: i, name: this.convertToHours(i)});
        }
    },
    submit(){
        let choosedDay = this.workingDays[this.choosedDayIndex];
        this.deliveryDate.year = choosedDay.getFullYear();
        this.deliveryDate.month = choosedDay.getMonth() + 1;
        this.deliveryDate.day = choosedDay.getDate();
        this.deliveryDate.hour = Math.floor(this.time / 60);
        this.deliveryDate.minute = this.time - (this.deliveryDate.hour * 60);
        this.deliveryDate.monthName = this.monthNames[choosedDay.getMonth()];
        this.deliveryDate.dateName = this.dayNames[choosedDay.getDay()];
        this.deliveryDate.fullTime = this.total;
        this.$emit('submit', this.deliveryDate, `${this.monthNamesShort[this.workingDays[this.choosedDayIndex].getMonth()]} ${this.workingDays[this.choosedDayIndex].getDate()} at ${this.total}`);
        this.showModal = false;
    },
    convertToDate(array){
        let newArray = [];
        array.forEach(element => {
            let tmpStart = element.start;
            let tmpEnd = element.end;
            let tmpStartString = tmpStart.slice(0, 4) + "/" + tmpStart.slice(4, 6) + "/" + tmpStart.slice(6, 8) + " " + tmpStart.slice(9) + ":00";
            let tmpEndString = tmpEnd.slice(0, 4) + "/" + tmpEnd.slice(4, 6) + "/" + tmpEnd.slice(6, 8) + " " + tmpEnd.slice(9) + ":00";
            element.start = new Date(tmpStartString);
            element.end = new Date(tmpEndString);
            newArray.push(element)
        })
        return newArray;
    },
    convertToHours(time){
        var hours1 = Math.floor(time / 60);
        var minutes1 = time - (hours1 * 60);

        if (hours1.toString().length === 1) hours1 = '0' + hours1;
        if (minutes1.toString().length === 1) minutes1 = '0' + minutes1;
        if (minutes1 == 0) minutes1 = '00';
        if (hours1 >= 12) {
            if (hours1 == 12) {
                hours1 = hours1;
                minutes1 = minutes1 + " PM";
            } else {
                hours1 = hours1 - 12;
                minutes1 = minutes1 + " PM";
            }
        } else {
            hours1 = hours1;
            minutes1 = minutes1 + " AM";
        }
        if (hours1 == 0) {
            hours1 = 12;
            minutes1 = minutes1;
        }
        return hours1 + ':' + minutes1;
    }
  },
  computed: {
    ...mapState(['info']),
    total: function () {
        return this.convertToHours(this.time);
    },
    cssProps() { return {
        ...mapState(["info"]),
        '--main-color': this.info.color ? "#" + this.info.color : "#c12d39"
      }
    }
  },
  created(){
          let thisRef = this;
          let today = new Date();
          this.workingDays.push(today);
          for(let i = 1; i < this.dayCount; i++){
              let nextDay = new Date(today.getTime() + (i * (24 * 60 * 60 * 1000)));
              this.workingDays.push(nextDay);
          }
          this.setMobileOptions();
    //       if(this.info.restaurant.id){
    //       let lastDay = this.workingDays[this.workingDays.length - 1];
    //       let from = `${today.getFullYear()}${(today.getMonth() + 1).toString().length === 1 ? '0' + (today.getMonth() + 1) : (today.getMonth() + 1).toString()}${today.getDate().toString().length === 1 ? '0' + today.getDate() : today.getDate()}`
    //       let to = `${lastDay.getFullYear()}${(lastDay.getMonth() + 1).toString().length === 1 ? '0'+ (lastDay.getMonth() + 1) : (lastDay.getMonth() + 1)}${lastDay.getDate().toString().length === 1 ? '0' + lastDay.getDate() : lastDay.getDate()}`;
          
    //       axios.get("https://secure-badlands-41449.herokuapp.com/restaurants/" + this.info.restaurant.id + "/calendars", {
    //           params: {
    //             from: from,
    //             to: to,
    //             includePrivate: false,
    //             key: "SPn4GGKDfK4ubhbWD0GbiHofFQwk7INP"
    //           }
    //       }).then(response => {
    //             this.calendars = response.data.calendar;
    //             let businessArray
    //             let deliveryArray
    //             let checkArray
    //             response.data.calendar.forEach(calendar => {
    //                 calendar.ranges = this.convertToDate(calendar.ranges);
    //                 if(calendar.type === 'delivery'){ deliveryArray = calendar.ranges}
    //                 if(calendar.type === 'business'){ businessArray = calendar.ranges}
    //             })
    //             if(this.info.method === "delivery" || this.info.method === "dispatch"){
    //                 if(deliveryArray) checkArray = deliveryArray
    //                 else checkArray = businessArray
    //             }
    //             else{
    //                 checkArray = businessArray
    //             }
    //             this.checking = checkArray;
    //             this.setWorkingHours();
            
    //       }).catch(error => console.log(error));
    //   }
  }
    
}
</script>
<style scoped>
.scrollTime
{
    display: none;
}
.not-work{
    
	height: 24px;
width: 240px;
border-radius: 4px;
background-color:var(--main-color);
color: #FFFFFF;
font-family: Poppins;
font-size: 10px;
font-weight: 500;
line-height: 16px;
position: relative;
top: 20px;
left: 25%;
text-align: center;

}

input[type=range] {
  -webkit-appearance: none;
  margin: 10px 0;
  width: 100%;
}
input[type=range]:focus {
  outline: none;
}
input[type=range]::-webkit-slider-runnable-track {
 width: 100%;
  height: 2px;
  background-color:rgba(0,0,0,0.1);
  cursor: pointer;
  animate: 0.2s;
  border-radius: 25px;
  margin-bottom: 5px;
}
input[type=range]::-webkit-slider-thumb {
  height: 38px;
  width: 38px;
  border:1px solid rgba(0,0,0,0.6);
  border-radius: 50%;
  background: #ffffff;;
  cursor: pointer;
  background-image: url('.../../../../../assets/images/group.png');
  background-repeat: no-repeat;
  background-size: 50%;
  background-position: 50% 50%;
  -webkit-appearance: none;
  margin-top: -18.2px;
}
input[type=range]:focus::-webkit-slider-runnable-track {
  background:var(--main-color);
}
input[type=range]::-moz-range-track {
  width: 100%;
  height: 2px;
  background-color:rgba(0,0,0,0.1);
  cursor: pointer;
  animate: 0.2s;
  border-radius: 25px;


}

input[type=range]::-moz-range-thumb {
 
  
  height: 38px;
  width: 38px;
  border:1px solid rgba(0,0,0,0.6);
  border-radius: 50%;
  background: #ffffff;;
  cursor: pointer;
  background-image: url('.../../../../../assets/images/group.png');
  background-repeat: no-repeat;
  background-size: 50%;
  background-position: 50% 50%

}



input[type=range]::-ms-track {
  width: 100%;
  height: 12.8px;
  cursor: pointer;
  animate: 0.2s;
  background: transparent;
  border-color: transparent;
  border-width: 39px 0;
  color: transparent;
}
input[type=range]::-ms-fill-lower {
  background: var(--main-color);
  border: 0px solid #000101;
  border-radius: 50px;
  box-shadow: 0px 0px 0px #000000, 0px 0px 0px #0d0d0d;
}
input[type=range]::-ms-fill-upper {
  background: var(--main-color);
  border: 0px solid #000101;
  border-radius: 50px;
  box-shadow: 0px 0px 0px #000000, 0px 0px 0px #0d0d0d;
}
input[type=range]::-ms-thumb {
 height: 38px;
  width: 38px;
  border:1px solid rgba(0,0,0,0.6);
  border-radius: 50%;
  background: #ffffff;;
  cursor: pointer;
  background-image: url('.../../../../../assets/images/group.png');
  background-repeat: no-repeat;
  background-size: 50%;
  background-position: 50% 50%
}
input[type=range]:focus::-ms-fill-lower {
  background: var(--main-color);
}
input[type=range]:focus::-ms-fill-upper {
  background: var(--main-color);
}

body {
  padding: 30px;
}

button
{
    border: none;
  padding: 0;
  background: none;
  outline: none;
}
.modal {
   position: fixed;;
  left:0;
  top: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  padding: 48px;
  box-sizing: border-box;
	height: 502px;
	width: 580px;
	border: 1px solid rgba(0,0,0,0.1);
	border-radius: 8px;
	background-color: #FFFFFF;
    z-index: 5;
}
.modal h1
{
   
	opacity: 0.8;
	color: #000000;
	font-family: Poppins;
	font-size: 16px;
	font-weight: bold;
	line-height: 25px;
	text-align: center;
}
.modal-overlay
{
   position: fixed; 
  width: 100%; 
  height: 100%; 
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.5); /* Black background with opacity */
  z-index: 1; 
}
.date-month
{
    width: 95%;
}
.date-month span
{
   
	opacity: 0.4;
	color: #000000;
	font-family: Poppins;
	font-size: 12px;
	font-weight: 500;
	line-height: 18px;
}
.day{
    
	height: 74px;
	width: 64px;
	border: 1px solid rgba(0,0,0,0.1);
	border-radius: 8px;
	background-color: #FFFFFF;
    margin-left: 2px;

}
.day span:first-child{

	opacity: 0.6;
	color: #000000;
	font-family: Poppins;
	font-size: 20px;
	font-weight: 300;
	line-height: 30px;
	text-align: center;

}
.day span:last-child
{
    
	opacity: 0.3;
	color: #000000;
	font-family: Poppins;
	font-size: 12px;
	font-weight: 500;
	line-height: 18px;
	text-align: center;

}
.date-days
{
    width: 100%;
}
.date-time
{
    padding-top: 48px;
}
.scroller
{
    padding-top: 37px;
}
.scroller span{
    
	opacity: 0.6;
	color: #000000;
	font-family: Poppins;
	font-size: 20px;
	font-weight: 300;
	line-height: 30px;
	text-align: center;
}

.scroller input{
    width: 80%;


}
.beet
{
    width: 80%;
}
.beet span
{

	opacity: 0.4;
	color: #000000;
	font-family: Poppins;
	font-size: 11px;
	font-weight: 500;
	line-height: 17px;
	text-align: right;
}
.button
{
    width: 100%;
    padding-top: 48px;
}

.button button:first-child 
{
  

	height: 48px;
	width: 160px;
	border: 1px solid var(--main-color);
	border-radius: 24px;
	background-color: #FFFFFF;

}
.button button:first-child span{
   
	opacity: 0.8;
	color: #000000;
	font-family: Poppins;
	font-size: 13px;
	font-weight: 500;
	line-height: 20px;
	text-align: center;
}
.button button:last-child
{
	height: 48px;
	width: 306px;
	border-radius: 24px;
	background-color: var(--main-color);
}
.button button:last-child span{
    
	color: #FFFFFF;
	font-family: Poppins;
	font-size: 13px;
	font-weight: 500;
	line-height: 20px;
	text-align: center;

}
.active
{
    border: 1px solid var(--main-color) !important;
}
.active span:first-child
{
    font-weight: bold !important;
    color: #000000 !important;
    opacity: 1 ;
}
.active span:last-child
{
    font-weight: 600 !important;
    color: #000000 !important;
    opacity: 1;
}



@media screen and (max-width: 600px) {
    .modal{
        width: 100%;
        padding: 22px;
        /* bottom: -200px; */
        height: 90%;
    }
    .date-month 
    {
        width: 100%;
    }
    .date-days
    {
        width: 100%;
    }
    .date-days div
    {
        width: 100% !important;
    }
    .date-days div button
    {
       width: 45px !important;
       
    }
    .scroller input {
        width: 75% !important;
    }
    .scroller span{
        white-space: nowrap;
        font-size: 16px !important;
    }
    .button
    {
        flex-direction: column-reverse !important;
        justify-content: center !important;
        align-items: center !important;

    }
    .button button:first-child
    {
        width: 100%;
        margin-top: 10px;
    }
    .button button:last-child
    {
        width: 100%;
    }
    .scroller{
        display: none !important;
    }
    .beet{
        display: none !important;
    }
    .scrollTime{
        display: block;
    }
    .date-days{
        
        overflow-x: scroll;
        white-space: nowrap;
       
    }
    .not-work{
        left: 16%;
        line-height:25px;
    }
   
   
}



</style>
<style>
.vue-scroll-picker-item{
       word-spacing: 1.5em !important;
   }
   .vue-scroll-picker-list{
       font-family: Poppins !important;
        font-size: 20px !important;
        font-weight: bold;
       

   }
   .vue-scroll-picker{
       height: 8em;
   }
   .vue-scroll-picker-layer .top{
       border-bottom:none !important;
   }
   .vue-scroll-picker-layer .bottom
   {
       border-top:none !important;
   }
   .vue-scroll-picker-layer .middle
   {
       border: 1px solid rgba(0,0,0,0.6);
       border-radius:8px;
   }
    

</style>





// WEBPACK FOOTER //
// src/components/steps/modals/dateModal.vue